<template>
  <div :class="props.mode === 'popup' ? 'pop pop-member-checking' : 'popup-box popup-set'">
    <div :class="props.mode === 'popup' ? 'popin' : 'setting-wrap bg-white popup'">
      <!-- 닫기 -->
      <div v-if="props.mode === 'popup'" class="btn-close" @click="emit('on-close-click')">
        <span class="blind">Close</span>
      </div>
      <button v-else class="icon-close" @click="hideProfilePopup" />
      <!-- 헤더 -->
      <div v-if="props.mode !== 'popup'" class="popup-top">
        <a class="back" @click="changeViewType('main')"><i class="icon-arrow-left-lg" /></a>
        <h2 class="tx-center popup-tit">
          {{ $t('계정') }}
        </h2>
      </div>

      <div :class="{ 'pop-con': props.mode === 'popup' }">
        <!-- 제목 -->
        <h2 v-if="props.mode === 'popup'" class="title">
          {{ $t('하나님의교회성도인증') }}
        </h2>
        <h3 v-else class="popup-heading">
          {{ $t('하나님의교회성도인증') }}
        </h3>

        <!-- 회원 -->
        <div v-if="integartionType === 'watv'" class="input-wrap">
          <div class="input">
            <input v-model="id" type="text" :placeholder="$t('watv아이디')" autocomplete="new-text">
            <input
              v-model="password"
              type="password"
              :placeholder="$t('비밀번호')"
              autocomplete="new-password"
              @keyup.enter="$integrateWatv"
            >
          </div>
          <p v-if="invalidMessage" class="error-message" v-html="invalidMessage" />
          <button class="login-button" @click="$integrateWatv">
            {{ $t('인증하기') }}
          </button>
          <div class="tx-center pd-t-10">
            <a class="btn-under" @click="changeIntegartionType('saint')">{{ $t('다른방법으로인증하기') }}</a>
          </div>
        </div>
        <!-- 비회원 -->
        <div v-if="integartionType === 'saint'" class="input-wrap">
          <div class="input">
            <input
              v-model="saintNo"
              type="text"
              :placeholder="$t('성도번호')"
              autocomplete="new-text"
              @input="handleSaintNoChange"
            >
            <input
              v-model="birthDate"
              type="date"
              placeholder="생년월일 ex. 19990131"
              autocomplete="new-password"
              @keyup.enter="$integrateSaint"
            >
          </div>
          <p v-if="invalidMessage" class="error-message" v-html="invalidMessage" />
          <button class="login-button" @click="$integrateSaint">
            {{ $t('인증하기') }}
          </button>
          <div class="tx-center pd-t-10">
            <a class="btn-under" @click="changeIntegartionType('watv')">{{ $t('watvid로인증하기') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type IntegartionType = 'watv' | 'saint'
const props = defineProps<{
  mode?: 'popup' // 단독팝업
}>()
const emit = defineEmits<{
  (e: 'on-close-click'): void
  (e: 'on-integration-success'): void
}>()
const { changeViewType, hideProfilePopup } = useProfile()
const { integrateWatv, jwtCookie, integrateSaint } = useAuth()
const { $t } = useNuxtApp()

const integartionType = ref<IntegartionType>('watv')

const id = ref('')
const password = ref('')

const saintNo = ref('')
const birthDate = ref('')

const invalidMessage = ref('')

const { locale } = useI18n()

function changeIntegartionType(type: IntegartionType) {
  invalidMessage.value = ''
  integartionType.value = type
}

async function $integrateWatv() {
  if (id.value === '') {
    invalidMessage.value = $t('아이디를입력해주세요')
    return
  }

  if (password.value === '') {
    invalidMessage.value = $t('비밀번호를입력해주세요')
    return
  }

  const { data } = await integrateWatv({
    id: id.value,
    pwd: password.value,
    languageGbSn: locale.value,
    os: window.navigator.userAgent,
  })

  if (data.value?.errorCode !== '00') {
    invalidMessage.value = data.value?.outMsgTxt?.replaceAll('\\n\\n', '<br />') ?? '로그인에 실패했습니다.'
    return
  }

  invalidMessage.value = ''
  jwtCookie.value = data.value.token

  emit('on-integration-success')
}

async function $integrateSaint() {
  if (saintNo.value === '') {
    invalidMessage.value = $t('성도번호를입력해주세요')
    return
  }

  if (birthDate.value === '') {
    invalidMessage.value = $t('생년월일을입력해주세요')
    return
  }

  const { data, error } = await integrateSaint({
    birthDate: birthDate.value.replaceAll('-', ''),
    saintNo: saintNo.value,
  })

  if (error.value?.data.message === 'watv-user') {
    invalidMessage.value = $t('watv회원입니다watvid로통합해주세요')
  }

  if (error.value) {
    invalidMessage.value = $t('성도번호와생년월일을잘못입력하셨습니다')
    return
  }

  if (data.value?.token) {
    jwtCookie.value = data.value.token
    emit('on-integration-success')
  }
}

async function handleSaintNoChange() {
  saintNo.value = saintNo.value.replace(/[^A-z 0-9]/g, '')

  let temp = ''
  if (saintNo.value.length > 3) {
    temp = `${saintNo.value.substring(0, 3)}-${saintNo.value.substring(3)}`
    saintNo.value = temp

    if (saintNo.value.length > 10) {
      temp = `${saintNo.value.substring(0, 10)}-${saintNo.value.substring(10)}`
      saintNo.value = temp
    }
  }
}
</script>
